module.exports = __webpack_public_path__ + "img/276.f2699aa7.jpg";